export default "__VITE_ASSET__c0ad9cf0__"